<template>
  <SimpleCard :class="{'ma-5': $vuetify.display.smAndUp}">
    <h2 class="mb-5 text-accent">
      OCH POWER {{ $t('ServiceName') }}
    </h2>
    <v-alert
      v-if="errorRes.detail"
      type="error"
      transition="scale-transition"
      :text="errorRes.detail"
      class="mb-3 mt-3"
    />

    <!-- Step 1 User/Password -->
    <template v-if="!formData.token">
      <TextInput
        v-model="formData.username"
        field-key="username"
        :label="$t('User.EmailAddress')"
        icon="mdi-email"
      />
      <PasswordInput
        v-model="formData.password"
        field-key="password"
        disable-show
        icon="mdi-lock"
        autocomplete="on"
        @keyup-enter="doLoginStep1()"
      />

      <GoogleLogin :callback="onSignIn" />

      <v-card-actions v-if="$vuetify.display.xs">
        <v-spacer />
        <ActionButton
          login
          @click="doLoginStep1()"
        />
      </v-card-actions>

      <v-card-actions v-else>
        <ForgotPasswordDialog />
        <v-spacer />
        <ActionButton
          login
          @click="doLoginStep1()"
        />
      </v-card-actions>

      <v-card-actions class="mt-3">
        <v-spacer />
        <SelectLanguage
          style="max-width: 150px;"
          real-time-mode
          class="ml-5"
        />
      </v-card-actions>

      <template v-if="$vuetify.display.xs">
        <v-card-actions>
          <div>
            <PreSignupDialog />
            <ForgotPasswordDialog />
          </div>
        </v-card-actions>
        <v-divider />
        <v-card-actions>
          <TermsLink color="grey" />
        </v-card-actions>
      </template>

      <v-card-actions v-else>
        <PreSignupDialog />
        <v-spacer />
        <TermsLink color="grey" />
      </v-card-actions>
    </template>

    <!-- Step 2 One time code -->
    <template v-else>
      <div class="mb-4">
        {{ $t('Login.EnterOneTimeCode') }}
      </div>
      <TextInput
        v-model="formData.one_time_code"
        field-key="code"
        :label="$t('User.OneTimeCode')"
      />
      <v-card-actions>
        <v-spacer />
        <ActionButton
          cancel
          @click="formData.token=null"
        />
        <ActionButton
          submit
          @click="doLoginStep2()"
        />
      </v-card-actions>
    </template>
  </SimpleCard>
</template>

<script>
import http from '../../library/no_session_http'
import settings from '../../settings'
import { toLoginSuccess } from '../../library/redirect'
import { mapGetters } from 'vuex'
import SelectLanguage from '../../components/parts/inputs/SelectLanguageInput'
import SimpleCard from '../../components/parts/card/SimpleCard'
import ActionButton from '../../components/parts/button/ActionButton'
import PreSignupDialog from '../../components/dialogs/PreSignupDialog'
import TextInput from '../../components/parts/inputs/TextInput'
import PasswordInput from '../../components/parts/inputs/PasswordInput'
import TermsLink from '../../terms/TermsLink'
import ForgotPasswordDialog from '../../components/dialogs/ForgotPasswordDialog'
import GoogleLogin from '../base/GoogleLogin.vue'
import axios from 'axios'

export default {
  components: {
    ForgotPasswordDialog,
    TermsLink,
    PasswordInput,
    TextInput,
    PreSignupDialog,
    ActionButton,
    SimpleCard,
    SelectLanguage,
    GoogleLogin
  },
  data: () => ({
    formData: {
      username: null,
      password: null,
      one_time_code: null,
      token: null
    },
    errorMessage: ''
  }),
  computed: {
    ...mapGetters(['errorRes'])
  },
  created () {
    this.$i18n.locale = this.getBrowserLanguage()
  },
  methods: {
    getBrowserLanguage () {
      let language = (window.navigator.languages && window.navigator.languages[0]) ||
        window.navigator.language ||
        window.navigator.userLanguage ||
        window.navigator.browserLanguage
      if (language.indexOf('-')) {
        language = language.split('-')[0]
      }
      return language
    },
    successStep1 (res) {
      // 認証ステップ1成功、ワンタイムコード入力
      this.formData.token = res.data.token
    },
    successStep2 (res) {
      // 認証ステップ2成功、tokenをLocalStorageに保存してリダイレクト
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('refresh', res.data.refresh)
      localStorage.setItem('session_id', res.data.session_id)
      toLoginSuccess()
    },
    doLoginStep1 () {
      // ユーザー名、パスワード認証
      http.post(settings.ApiUrl + 'token-auth-s1/', {
        email: this.formData.username,
        password: this.formData.password
      }).then(
        (res) => {
          this.successStep1(res)
        }
      ).catch(error => {
        const errorMessage = this.extractErrorMessage(error)
        this.$store.dispatch('triggerNotification', {
          message: errorMessage,
          alignment: 'left'
        })
      })
    },
    doLoginStep2 () {
      // ワンタイムコード認証
      const requestData = {
        token: this.formData.token,
        one_time_code: this.formData.one_time_code
      }
      http.post(settings.ApiUrl + 'token-auth-s2/', { ...requestData }, { withCredentials: true }).then(
        (res) => {
          this.successStep2(res)
        }
      ).catch(error => {
        this.errorRes = error.response.data
        const errorMessage = this.extractErrorMessage(error)
        this.$store.dispatch('triggerNotification', {
          message: errorMessage,
          alignment: 'left'
        })
      })
    },
    extractErrorMessage (error) {
      return error.response.data.non_field_errors ? error.response.data.non_field_errors[0] : 'An error occurred'
    },
    onSignIn (googleUser) {
      axios.post(settings.ApiUrl + 'verify-google/', {
        token: googleUser.credential
      }, { withCredentials: true }).then((res) => {
        this.$store.dispatch('clearErrorRes')
        this.$store.dispatch('ui', { loading: false })
        this.successStep2(res)
      }).catch((error) => {
        this.$store.dispatch('ui', { loading: false })
        this.$store.dispatch('alert', {
          title: this.$t('SocialAccounts.loginWithGoogleFailureTitle'),
          body: this.$t('SocialAccounts.loginWithGoogleFailureContent')
        })
      })
    }

  }
}
</script>
